import FormattedMessage from 'I18n/components/FormattedMessage';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/transitional/components/View';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Image } from 'foundations-components/transitional/components/Image';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { HR } from 'foundations-components/transitional/components/HR';
import { validateAuthStep } from '../../../stepRenderer';
import { IntroStep } from './steps/IntroStep';
import { LowLevelFinishAuthButton } from './LowLevelFinishAuthButton';
import { ModalOrInlineLayout } from '../ModalOrInlineLayout';
import { useLowLevelAuthFlowMachine } from './LowLevelAuthFlowMachineContext';
import { useAuthFlowActions } from './hooks';
import { AuthErrorSection, AuthStepItemsList } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NO_OP_INTRO = {
  render: null
};
const defaultUseIntroConfig = () => NO_OP_INTRO;
export function WizardAuthFlowLayout({
  isModal,
  header,
  isReauth,
  authFlowType,
  useIntroScreen,
  processError,
  errorContext
}) {
  const {
    state,
    send
  } = useLowLevelAuthFlowMachine();
  const {
    authConfig,
    params,
    authError,
    stepIndex,
    initialStepIndex
  } = state.context;
  const {
    appName,
    appIcon,
    authFlow
  } = authConfig;
  const {
    handleParamChange
  } = useAuthFlowActions();
  const introConfig = (useIntroScreen !== null && useIntroScreen !== void 0 ? useIntroScreen : defaultUseIntroConfig)({
    type: authFlowType,
    appName,
    onDone: () => send({
      type: 'GO_TO_NEXT_STEP'
    })
  });
  const currentStep = stepIndex > -1 && stepIndex < authFlow.steps.length ? authFlow.steps[stepIndex] : undefined;
  const isIntroScreen = stepIndex === -1 || !currentStep;
  const isLastStep = stepIndex === authFlow.steps.length - 1;
  const canGoBack = stepIndex > initialStepIndex;
  const isValidStep = currentStep ? validateAuthStep(currentStep, params) : true;
  const isFinishButtonDisabled = !isValidStep || isIntroScreen && !!introConfig.connectButtonDisabled;
  const finishButtonLabel = isIntroScreen ? introConfig.connectButtonLabel : undefined;
  const handleNextStep = () => {
    send({
      type: 'GO_TO_NEXT_STEP'
    });
  };
  const handlePrevStep = () => {
    send({
      type: 'GO_TO_PREV_STEP'
    });
  };
  return /*#__PURE__*/_jsx(ModalOrInlineLayout, {
    isModal: isModal,
    header: header,
    body: /*#__PURE__*/_jsxs(Section, {
      paddingBlockEnd: "100",
      children: [currentStep && /*#__PURE__*/_jsxs(_Fragment, {
        children: [!isReauth && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(MediaObject, {
            align: "center",
            itemLeft: appIcon ? /*#__PURE__*/_jsx(Image, {
              src: appIcon,
              blockSize: "40px",
              inlineSize: "40px",
              objectFit: "contain"
            }) : /*#__PURE__*/_jsx(Illustration, {
              name: "integrations",
              blockSize: "40px",
              inlineSize: "40px"
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "unifiedAuthCore.auth.connectIntro",
              options: {
                appName
              }
            })
          }), /*#__PURE__*/_jsx(HR, {})]
        }), /*#__PURE__*/_jsx(AuthErrorSection, {
          appName: appName,
          authError: authError,
          errorContext: errorContext,
          processError: processError
        }), /*#__PURE__*/_jsx(AuthStepItemsList, {
          items: currentStep.items,
          params: params,
          onParamChange: handleParamChange
        })]
      }), !currentStep && isIntroScreen && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AuthErrorSection, {
          appName: appName,
          authError: authError,
          errorContext: errorContext,
          processError: processError
        }), introConfig.render ? introConfig.render() : /*#__PURE__*/_jsx(IntroStep, {
          type: authFlowType,
          appName: appName
        })]
      })]
    }),
    footer: /*#__PURE__*/_jsx(ButtonWrapper, {
      paddingInlineStart: "0",
      paddingBlockStart: "0",
      children: /*#__PURE__*/_jsxs(View, {
        paddingInlineStart: "0",
        children: [canGoBack && /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: handlePrevStep,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "unifiedAuthCore.auth.back"
          })
        }), !isLastStep && /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: handleNextStep,
          disabled: !isValidStep,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "unifiedAuthCore.auth.next"
          })
        }), isLastStep && /*#__PURE__*/_jsx(LowLevelFinishAuthButton, {
          disabled: isFinishButtonDisabled,
          label: finishButtonLabel
        })]
      })
    })
  });
}